// Layout
import Breadcrumbs from '@/components/ui/Breadcrumbs'

// Components
import ServiceCasesKanban from '@/components/service_cases/ServiceCasesKanban'

export default function ServicesPage() {
    const breadcrumbs = [
        {
            label: 'Service après-vente',
        },
    ]

    return (
        <div>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <ServiceCasesKanban />
        </div>
    )
}
